import React, { Suspense } from 'react'
import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'

import Preloader from './components/Preloader'
import Homepage from './pages/General/Homepage'
import DashboardHome from './pages/Admin/DashboardHome'
import AdminPath from './AdminPath'
import GeneralPath from './GeneralPath'
import UserPath from './UserPath'
import Projects from './pages/General/Projects'
import About from './pages/General/About'
import Login from './pages/General/Login'
import Signup from './pages/General/Signup'
import Privacy from './pages/General/Privacy'
import Terms from './pages/General/Terms'
import Contact from './pages/General/Contact'
import CampaignDetail from './pages/General/CampaignDetail'
import ProjectDetail from './pages/General/ProjectDetail'
import Professionals from './pages/General/Professionals'
import ProfessionalsSearch from './pages/General/ProfessionalsSearch'
import ProfessionalDetail from './pages/General/ProfessionalDetail'

import VerifyEmail from './pages/User/VerifyEmail'

import UserDashboardHome from './pages/User/UserDashboardHome'
import UserDashboardProfile from './pages/User/UserDashboardProfile'
import UserDashboardSubmissions from './pages/User/UserDashboardSubmissions'
import UserDashboardNotifications from './pages/User/UserDashboardNotifications'
import UserDashboardProjects from './pages/User/UserDashboardProjects'
import UserDashboardSubmissionDetails from './pages/User/UserDashboardSubmissionDetails'
import UserDashboardNewSubmission from './pages/User/UserDashboardNewSubmission'
import AdminLogin from './pages/General/AdminLogin'
import DashboardCampaign from './pages/Admin/DashboardCampaign'
import DashboardSubmissions from './pages/Admin/DashboardSubmissions'
import DashboardSingleSubmission from './pages/Admin/DashboardSingleSubmission'
import DashboardNotifications from './pages/Admin/DashboardNotifications'
import DashboardProfessionals from './pages/Admin/DashboardProfessionals'
import DashboardSingleProfessional from './pages/Admin/DashboardSingleProfessional'
import DashboardProfile from './pages/Admin/DashboardProfile'
import DashboardUsers from './pages/Admin/DashboardUsers'
import DashboardSingleUser from './pages/Admin/DashboardSingleUser'

const App = () => {
	return (
		<>
			<BrowserRouter>
				<Suspense fallback={<Preloader />}>
					<Routes>
						{/* ------------------------------ Verify route ------------------------------ */}
						<Route
							path='/email/verify/:id/:tokenId'
							element={<VerifyEmail />}
						/>
						{/* ------------------------------------------------------------------------------ */}

						{/* ------------------------------ genral routes  ---------------------------------- */}
						<Route path='/' element={<Navigate replace to='/home' />} />
						<Route path='/' element={<GeneralPath />}>
							<Route path='home' element={<Homepage />} />
							<Route path='projects' element={<Projects />} />
							<Route path='privacy-policy' element={<Privacy />} />
							<Route path='terms' element={<Terms />} />
							<Route path='contact' element={<Contact />} />
							<Route path='professionals' element={<Professionals />} />
							<Route
								path='professionals/:id'
								element={<ProfessionalDetail />}
							/>
							<Route
								path='professionals/search'
								element={<ProfessionalsSearch />}
							/>
							<Route path='campaign/:slug' element={<CampaignDetail />} />
							<Route path='projects/:slug' element={<ProjectDetail />} />
							<Route path='about-us' element={<About />} />
							<Route path='login' element={<Login />} />
							<Route path='2022/feem/login/admin' element={<AdminLogin />} />
							<Route path='register' element={<Signup />} />
						</Route>
						{/* ------------------------------------------------------------------------------------  */}

						{/* --------------------------------------- admin routes ---------------------------------- */}
						<Route
							path='admin/dashboard'
							element={<Navigate replace to='/admin/dashboard/home' />}
						/>
						<Route path='/admin/dashboard' element={<AdminPath />}>
							<Route path='home' element={<DashboardHome />} />
							<Route path='campaigns' element={<DashboardCampaign />} />
							<Route path='submissions' element={<DashboardSubmissions />} />
							<Route
								path='submissions/:id'
								element={<DashboardSingleSubmission />}
							/>
							<Route
								path='notifications'
								element={<DashboardNotifications />}
							/>
							<Route
								path='professionals'
								element={<DashboardProfessionals />}
							/>
							<Route
								path='professionals/:slug'
								element={<DashboardSingleProfessional />}
							/>
							<Route path='profile' element={<DashboardProfile />} />
							<Route path='users' element={<DashboardUsers />} />
							<Route path='users/:slug' element={<DashboardSingleUser />} />
						</Route>
						{/* ------------------------------------------------------------------------------------------  */}

						{/* ----------------------------------- User dashboard ----------------------------------------- */}
						<Route
							path='user/dashboard'
							element={<Navigate replace to='/user/dashboard/home' />}
						/>
						<Route path='/user/dashboard' element={<UserPath />}>
							<Route path='home' element={<UserDashboardHome />} />
							<Route path='profile' element={<UserDashboardProfile />} />
							<Route
								path='submissions'
								element={<UserDashboardSubmissions />}
							/>
							<Route
								path='submissions/create'
								element={<UserDashboardNewSubmission />}
							/>
							<Route
								path='notifications'
								element={<UserDashboardNotifications />}
							/>
							<Route path='projects' element={<UserDashboardProjects />} />
							<Route
								path='submissions/:slug'
								element={<UserDashboardSubmissionDetails />}
							/>
						</Route>
						{/* --------------------------------------------------------------------------------------------------  */}
					</Routes>
				</Suspense>
			</BrowserRouter>
			<Toaster />
		</>
	)
}

export default App
